<template> 
  <div>
    <v-menu
      v-model="showMenu"
      offset-y
      max-height="300px"
      max-width="300px"
    >
      <template v-slot:activator>
        <v-textarea
          v-if="textarea"
          :value="value"
          @input="value = $event; $emit('input', $event)"
          @keyup="updateTagMenu"
          @click="updateTagMenu"
          ref="field"
          :label="label"
          :filled="!outlined"
          :outlined="outlined"
          :no-resize="noResize"
          hide-details
        ></v-textarea>
        <v-text-field
          v-else
          :value="value"
          @input="value = $event; $emit('input', $event)"
          @keyup="updateTagMenu"
          @click="updateTagMenu"
          ref="field"
          :label="label"
          :filled="!outlined"
          :outlined="outlined"
          hide-details
        ></v-text-field>
      </template>
      <v-list v-if="tagItems.length > 0">
        <v-list-item
          v-for="(item, index) in tagItems"
          :key="index"
          @click="onClickTagItem(item.ref)"
        >
          <v-list-item-avatar v-if="!item.action">
            <v-img :src="item.picture" class="primary" />
          </v-list-item-avatar>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog
      v-model="randSeedDlg.show" 
      max-width="320"
      @keydown.enter="onRandSeedDlgConfirm"
    >
      <v-card>
        <v-card-title class="headline">Random profile</v-card-title>
        <v-radio-group v-model="randSeedDlg.sex" row class="ma-0 pa-0 mt-2 ml-6">
          <v-radio label="Male" value="male" />
          <v-radio label="Female" value="female" />
        </v-radio-group>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="onRandSeedDlgConfirm"
          >
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog
      v-model="inputSeedDlg.show"
      max-width="320"
      @keydown.enter="onInputSeedDlgConfirm"
    >
      <v-card>
        <v-card-title class="headline">Input seed</v-card-title>
        <v-text-field
          v-model="inputSeedDlg.seed"
          class="ma-0 pa-0 mx-6"
          placeholder="Seed"
          hide-details />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="onInputSeedDlgConfirm"
          >
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { randomSeed } from '../random-fb-profile'
const maxTagItems = 32
const randSeedRef = 'RAND_SEED'
const inputSeedRef = 'INPUT_SEED'

export default {
  name: 'FbTextField',
  injectModels: ['Store'],
  props: {
    value: String,
    label: String,
    textarea: Boolean,
    outlined: Boolean,
    noResize: Boolean
  },
  data() {
    return {
      query: '',
      showMenu: false,
      randSeedDlg: {
        show: false,
        sex: 'male'
      },
      inputSeedDlg: {
        show: false,
        seed: ''
      }
    }
  },
  computed: {
    tagItems() {
      const randomActions = [{
        ref: randSeedRef,
        action: true,
        name: 'Random profile'
      }, {
        ref: inputSeedRef,
        action: true,
        name: 'Input seed'
      }]
      return [
        ...(this.query === '' ? randomActions : []),
        ...this.Store.fbMembers(this.query).slice(0, maxTagItems)
      ]
    }
  },
  methods: {
    updateTagMenu() {
      const result = this.getTagQuery()
      if (result == null) {
        this.showMenu = false
        return
      }

      this.query = result.query.substr(1)
      this.showMenu = this.tagItems.length > 0
    },
    getTagQuery() {
      const el = this.textarea ? 'textarea' : 'input'
      const input = this.$refs.field.$el.querySelector(el)
      const caretPos = input.selectionStart

      const lookup = this.value.substring(0, caretPos)
      const lastSp = Math.max(0, lookup.lastIndexOf(' '))
      const lastAt = lookup.lastIndexOf('@')

      if (lastSp > lastAt)
        return null
      
      return {
        query: lookup.substring(lastAt),
        from: lastAt,
        to: caretPos
      }
    },
    onClickTagItem(ref) {
      if (ref === randSeedRef) {
        this.randSeedDlg.show = true
      } else if (ref === inputSeedRef) {
        this.inputSeedDlg.show = true
      } else {
        this.insertTag(ref)
      }
    },
    insertTag(ref) {
      const result = this.getTagQuery()

      if (result != null) {
        const pre = this.value.substr(0, result.from)
        const post = this.value.substring(result.to)

        this.value = pre + ref + ' ' + post.trimStart()
        this.$emit('input', this.value)
      }
    },
    onRandSeedDlgConfirm() {
      const male = this.randSeedDlg.sex === 'male'
      const seed = randomSeed(male)
      this.insertTag(`@R:${seed}`)
      this.randSeedDlg.show = false
    },
    onInputSeedDlgConfirm() {
      const seed = this.inputSeedDlg.seed || '1p'
      this.insertTag(`@R:${seed}`)
      this.inputSeedDlg.show = false
    }
  }
}
</script>
